<template>
  <div class="container">
    <div class="fixed-cards">
      <!-- 商户报单详情的表单 -->
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商户报单信息:</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col :span="8"><strong>客户姓名:</strong> {{ info.customName }}</el-col>
            <el-col :span="8"><strong>客户手机号:</strong> {{ info.customMobile }}</el-col>
            <el-col :span="8"><strong>客户地址:</strong> {{ info.customAddress }}</el-col>
          </el-row>
          <!-- 店铺信息：shopName、shopAddress、shopMobile -->
          <el-row>
            <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
            <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
            <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>预计安装时间:</strong> {{ formatDate(info.installTime) }}</el-col>
            <el-col :span="8"><strong>零售价:</strong> {{ info.retailPrice }}</el-col>
            <el-col :span="8"><strong>预埋:</strong> {{ info.preEmbedded }}</el-col>
            <el-col v-if="info.lineLength" :span="8"><strong>管线预埋长度:</strong> {{ info.lineLength ? info.lineLength + '米'
              : '无' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>备注:</strong> {{ info.remarks }}</el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <div class="fixed-cards">
      <!-- 商品选择表格 -->
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商品列表:</span>
        </div>
        <div class="card-content">
          <el-table :data="selectedGoods" style="width: 100%" border>
            <el-table-column prop="name" label="商品名称">
            </el-table-column>
            <el-table-column prop="num" label="数量">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.serviceOrderId && scope.row.serviceOrderId.length > 1">
                  <el-button v-for="(id, index) in scope.row.serviceOrderId" :key="index" :disabled="!id" type="text"
                    icon="el-icon-view" @click="viewWorkOrder({ serviceOrderId: id })" style="margin-top: 10px;">
                    工单{{ index + 1 }}
                  </el-button>
                </div>
                <div v-else>
                  <el-button :disabled="!scope.row.serviceOrderId" type="text" icon="el-icon-view"
                    @click="viewWorkOrder(scope.row)" style="margin-top: 10px;">
                    工单
                  </el-button>
                </div>
              <el-button :disabled="!scope.row.serviceOrderId" type="text" icon="el-icon-view"
                @click="viewEvaluation(scope.row.viewEvaluatId)" style="margin-top: 10px;">
                查看评价
              </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 提交和返回按钮 -->
        <div class="fixed-cards">
          <div class="card-content" style="text-align: center;">
            <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
          </div>
        </div>
      </el-card>
      <viewOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :evaluateInfo="evaluateInfo" />
    </div>
  </div>
</template>

<script>
import { getMerchantOrder, getGoodList } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { resolveUrlPath } from "@/util/util";
import viewOrder from "./components/viewOrder.vue";
export default {
  components: {
        viewOrder,
    },
  data() {
    return {
      goodsList: [], // 商品列表
      selectedGoods: [], // 用户选择的商品
      info: {
        installTime: null,
      }, // 表单数据
      isFormReadOnly: true, // 整个表单是否只读
      viewOrderVisible: false,
      orderId: "",
      evaluateInfo: false,
    };
  },
  created() {
    const id = this.$route.query.id;

    if (id) {
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          console.log('data::: ', data);
          this.info = data;
          this.info.picUrl = data.picUrl || [];  // 确保 picUrl 存在并赋值
          
          // 当data.list存在时使用，否则调用getGoodList接口获取数据
          if (data.list && data.list.length > 0) {
              console.log('view.vue ~ line: 116 ~ data.list ->', data.list);
            this.processSelectedGoods(data.list);
          } else {
            // 调用getGoodList接口获取商品数据
            getGoodList(id).then(res => {
              if (res.code === '200') {
                const goodsData = JSON.parse(res.data);
                this.selectedGoods = goodsData;
                this.processSelectedGoods(goodsData);
              } else {
                this.$message.error('获取商品列表失败');
                // 即使获取失败，也传入空数组以避免后续错误
                this.processSelectedGoods([]);
              }
            }).catch(() => {
              this.$message.error('获取商品列表接口调用失败');
              this.processSelectedGoods([]);
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  methods: {
    viewEvaluation(id) {
      this.viewOrderVisible = true;
      this.orderId = id;
      this.evaluateInfo = true;
    },
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime(); // 将日期转换为时间戳
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null; // 如果没有选择时间，则设置为null
      }
    },
    // 处理商品列表并回显
    processSelectedGoods(selectedGoods) {
      const type = 'PURE_WATER'
      // 使用导入的API函数
      findPureWaterGoodsByRootDepartId(type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            // 确保selectedGoods是数组
            if (Array.isArray(selectedGoods)) {
              /* this.selectedGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId || '',
                declarationId: item.declarationId || '',
                name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : ""
              })); */
              this.selectedGoods = selectedGoods.map(item => ({
              goodsId: item.goodsId,
              num: item.num,
              serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
              viewEvaluatId: item.deliveryOrder ? item.deliveryOrder.id : null,
              declarationId: item.declarationId || '',
              name: this.goodsList.find(g => g.id == item.goodsId) ? this.goodsList.find(g => g.id == item.goodsId).name : ""
            }));
              console.log('view.vue ~ line: 177 ~ selectedGoods ->', selectedGoods);
            } else {
              this.selectedGoods = [];
              this.goodsList = [];
            }
          } else {
            this.goodsList = [];
            this.selectedGoods = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    viewWorkOrder(row) {
      let obj = {
        label: "查看工单",
        value: "/work/waterProject/engineer/engineerDetails",
        id: row.serviceOrderId
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: { GoodsId: obj.id }
      });
    },

    // 返回上一步
    goBack() {
      /* let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1); */
      window.close();
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  min-height: 80%;
  box-sizing: border-box;
  font-family: fangsong;
  font-size: large;
}

.fixed-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 20px;
}

/* 确保表格的字体与其他部分一致 */
.el-table {
  font-family: fangsong;
  font-weight: bold;
  font-size: large;
}

.el-table th,
.el-table td {
  font-family: fangsong;
  font-size: large;
}

.el-table th {
  font-family: fangsong;
  font-size: large;
}
</style>
